function createStreamStateElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

export function renderAuthRequiredStream(root) {
  if (!root) return;
  const hint = createStreamStateElement('div', 'aichat-empty-hint');
  const login = createStreamStateElement('a', '', '登录');
  login.href = '/login.html';
  hint.append(document.createTextNode('请先 '), login, document.createTextNode(' 后使用 AI 对话'));
  root.replaceChildren(hint);
}

export function renderSessionLoadFailure(root) {
  if (!root) return;
  const hint = createStreamStateElement('div', 'aichat-empty-hint');
  const reload = createStreamStateElement('button', 'aichat-stream-state-action', '点击刷新');
  reload.type = 'button';
  reload.dataset.action = 'reload-page';
  hint.append(document.createTextNode('会话加载失败，'), reload);
  root.replaceChildren(hint);
}
